import React from "react";
import { sortBy } from "lodash";

import Grid from "@mui/material/Grid2";

import { DemographicCard } from "@/components/atoms";
import { InsightResult } from "@/types";
import { useTheme } from "@mui/material/styles";

interface DemographicsSectionProps {
  insights: InsightResult[];
  score: string;
  compareMode?: boolean;
  gradient?: string[];
}

const DemographicsSection: React.FC<DemographicsSectionProps> = ({
  insights,
  score,
  compareMode,
  gradient
}) => {
  const demographics = ["Age Band", "Income Band", "Lifestage"];
  const weights = [6, 7, 8]
  const theme = useTheme();

  const getDemographicValues = (demographic: string) => {
    const demographics = insights.filter((x) => x.tag_type === "Demographics");
    return sortBy(
      demographics.filter((x) => x.tag_category === demographic),
      "tag_id"
    );
  };

  return (
    <Grid
      container
      size={12}
      sx={{
        flexWrap: { xs: 'wrap', lg: 'nowrap' },
        width: '100%',
        margin: 0,
        boxSizing: 'border-box',

        // Partial expand on big screens
        [theme.breakpoints.up('lg')]: {
          height: 110,
          mt: 4,
          '& .category-item': {
            transition: theme.transitions.create(['flex', 'flex-grow'], {
              duration: theme.transitions.duration.shorter,
            }),
          },
          '& .category-item:hover': {
            flex: '22 1 0px !important',
          },
        },
      }}
    >
      {demographics.map((demographic, index) => {
        const values = getDemographicValues(demographic);

        return (
          <Grid
            key={index}
            size={12}
            className="category-item"
            sx={{
              minWidth: 0,
              overflow: 'hidden',
              boxSizing: 'border-box',

              [theme.breakpoints.down('lg')]: {
                // Inital state - equal space
                flex: '1 0 100% !important',
                maxWidth: '100% !important',
              },

              [theme.breakpoints.up('lg')]: {
                // Inital state - equal space
                flex: `${weights[index]} 1 0px !important`,
                maxWidth: 'none !important',
                transition: theme.transitions.create(['flex', 'flex-grow'], {
                  duration: theme.transitions.duration.shorter,
                }),
              },

              '&:hover': {
                '& .demog-text': {
                  opacity: 1,
                  transform: 'translateY(0)',
                  transitionDelay: `${theme.transitions.duration.shorter}ms`,
                },
              },
            }}
          >
            <DemographicCard
              demographic={demographic}
              values={values}
              score={score}
              center={compareMode}
              gradient={gradient}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default DemographicsSection;
